import type { Effect } from "effect";
import type { ChatSnapshot } from "./model.ts";
import { emptyChatSnapshot } from "./model.ts";
import type { ChatQuery } from "./query-owner.ts";
export interface ChatState {
  readonly view: ChatSnapshot;
  readonly epoch: number;
  readonly stationEpoch: number;
  readonly drafts: ReadonlyMap<string, string>;
  readonly pending: ReadonlySet<string>;
  readonly configQuery: ChatQuery | null;
  readonly threadsQuery: ChatQuery | null;
  readonly tailQuery: ChatQuery | null;
  readonly timer: ChatQuery | null;
  readonly pollGeneration: number;
  readonly kickPending: boolean;
  readonly cursor: number;
  readonly applied: number;
  readonly historyLoaded: boolean;
  readonly merged: ReadonlySet<string>;
  readonly invalidate: Effect.Effect<void>;
}
export const initialChatState = (invalidate: Effect.Effect<void>): ChatState => ({
  view: emptyChatSnapshot(), epoch: 0, stationEpoch: 0, drafts: new Map(), pending: new Set(),
  configQuery: null, threadsQuery: null, tailQuery: null, timer: null,
  pollGeneration: 0, kickPending: false, cursor: 0, applied: 0, historyLoaded: false,
  merged: new Set(), invalidate
});
